import service from "../services/permissions-service";
import ServiceX from "@/helpers/py-service";

const state = {
  isLoadingPermissions: false,
  listPermissions: [],
  permissionDropDown: [],
  tiersOptions: [],
  meta: {},
};

const mutations = {
  SET_PERMISSIONS(state, listPermissions) {
    state.listPermissions = listPermissions;
  },
  SET_PERMISSIONS_DROPDOWN(state, payload) {
    state.permissionDropDown = payload;
  },
  SET_TIERS_OPTIONS(state, payload) {
    state.tiersOptions = payload;
  },

  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
};

const actions = {
  list: (store, params) => {
    if (store.state.permissionDropDown.length > 0) return;
    store.state.isLoadingPermissions = true;
    service.list(params).then((data) => {
      store.commit("SET_PERMISSIONS", data.body.permissions);
      // store.commit("SET_PERMISSIONS_DROPDOWN", data.body.permissions);
      store.state.isLoadingPermissions = false;
    });
  },
  permissionDropDown: (store, params) => {
    store.state.isLoadingPermissions = true;
    ServiceX.get("/roles-and-permissions/permissions-management", params).then(
      (data) => {
        store.commit("SET_PERMISSIONS", data.body.permissions);
        store.commit("SET_META", data);
        store.state.isLoadingPermissions = false;
      }
    );
  },
  tiersOptions: (store, params) => {
    service.productTiersOption(params).then((data) => {
      store.commit("SET_TIERS_OPTIONS", data.body.data);
    });
  },
  tiersPermissionList: (store, params) => {
    store.state.isLoadingPermissions = true;
    service.productTiersPermission(params).then((data) => {
      store.commit("SET_PERMISSIONS", data.body.permissions);
      store.commit("SET_META", data);
      store.state.isLoadingPermissions = false;
    });
  },
};

const getters = {
  isLoadingPermissions(state) {
    return state.isLoadingPermissions;
  },

  listPermissions(state) {
    return state.listPermissions;
  },
  getTiersOptions(state) {
    return state.tiersOptions;
  },
  meta(state) {
    return state.meta;
  },
};

const permissions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default permissions;
